import React, { useEffect, useMemo, useState } from 'react';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { Environment } from 'src/Environment';
import { createBrowserHistory as createHistory } from 'history';
import { initializeProductImageMap } from 'src/features/order/tech-debt/product-details-extra';
import { staticRoutes } from '../routing/router';
import toastMessageServiceSingleton from '../services/toast-message.service';
import MiniAppEvents from 'src/helpers/miniapp-events';
import { DevTools } from 'src/components';
import { DEBUG_CONFIG_KEY, DEV_TOOLS_KEY } from 'src/common';
import { webAppDynamicsObject } from 'src/utils/AppDynamics/WebAppDynamics';
import './app.scss';

export function App() {
  const history = createHistory();
  const inMiniProgram = MiniAppEvents.isInMiniApp();

  const [showDevTools, setShowDevTools] = useState(false);

  useEffect(initializeProductImageMap, []);

  useEffect(() => {
    webAppDynamicsObject.run();

    const unlisten = history.listen(() => toastMessageServiceSingleton.removeAllToasts());
    return () => unlisten();
  });

  useEffect(() => {
    if (inMiniProgram) {
      MiniAppEvents.sendMessage({
        messageType: 'get_platform',
      });

      MiniAppEvents.listenForMessage((observer) => {
        const message = MiniAppEvents.readMessage();
        if (message.type === 'get_platform') {
          if (message.data) {
            sessionStorage.setItem('platform', message.data);
            if (MiniAppEvents.isiOS()) {
              const root = document.getElementById('root');
              if (root) {
                root.addEventListener('touchstart', (e) => {
                  try {
                    const touchX = e.touches[0].clientX;
                    // is not near edge of view, don't prevent default
                    if (touchX > 10 && touchX < window.innerWidth - 10) return;

                    // prevent swipe to navigate gesture
                    e.preventDefault();
                  } catch (error) {
                    //Don't do anything if errors
                    return;
                  }
                });
              }
            }
          }
          observer.disconnect();
        }
      });
    }
  }, [inMiniProgram]);

  useMemo(() => {
    const devToolsParam = new URLSearchParams(window.location.search).get(DEV_TOOLS_KEY);

    if (devToolsParam && devToolsParam.toLowerCase() === 'false') {
      sessionStorage.removeItem(DEV_TOOLS_KEY);
      sessionStorage.removeItem(DEBUG_CONFIG_KEY);
      setShowDevTools(false);
    }

    if (devToolsParam && devToolsParam.toLowerCase() === 'true') {
      sessionStorage.setItem(DEV_TOOLS_KEY, devToolsParam);
      setShowDevTools((devToolsParam && Environment.current.allowDevTools) || false);
    } else {
      const devTools = sessionStorage.getItem(DEV_TOOLS_KEY);
      setShowDevTools((devTools && Environment.current.allowDevTools) || false);
    }
  }, []);

  return (
    <div>
      {Environment.current?.disabledFeatures
        ?.merchantRoutingForBcaAndSelfServiceAndUseBrowserRouter ? (
        <HashRouter>{staticRoutes}</HashRouter>
      ) : (
        <BrowserRouter>{staticRoutes}</BrowserRouter>
      )}
      {showDevTools && <DevTools />}
    </div>
  );
}
